import { render, staticRenderFns } from "./loginSettings.vue?vue&type=template&id=9fff1b4e&scoped=true"
import script from "./loginSettings.vue?vue&type=script&lang=js"
export * from "./loginSettings.vue?vue&type=script&lang=js"
import style0 from "./loginSettings.vue?vue&type=style&index=0&id=9fff1b4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fff1b4e",
  null
  
)

export default component.exports